import { useState } from "react";
import { CreatePromotion } from "src/components/CreatePromotion/CreatePromotion";
import CustomerPromotions from "src/components/CustomerPromotions/CustomerPromotions";
import ExistingCustomerPromotions from "src/components/ExistingCustomerPromotions/ExistingCustomerPromotions";
import { ReportPageLayout } from "src/features/Reports/components/ReportPageLayout";
import { ReportTabs } from "src/features/Reports/components/ReportTabs";

const PROMOTIONS_TABS = [
  { id: "promotions", label: "Promotions" },
  { id: "codes", label: "Codes" },
  { id: "insights", label: "Insights" },
];

const Promotions = () => {
  const [activeTab, setActiveTab] = useState("promotions");

  return (
    <ReportPageLayout
      compactTop
      toolbarMarginTop={0}
      toolbarMarginBottom={0}
      toolbar={
        <div className="flex items-center justify-between gap-4 w-full min-w-0">
          <ReportTabs
            tabs={PROMOTIONS_TABS}
            activeTabId={activeTab}
            onSelect={setActiveTab}
            inline
          />
        </div>
      }
    >
      {activeTab === "promotions" && <CustomerPromotions />}
      {activeTab === "codes" && <CreatePromotion />}
      {activeTab === "insights" && <ExistingCustomerPromotions />}
    </ReportPageLayout>
  );
};

export default Promotions;
